// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, tupleOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

const isStat = arrayOf(tupleOf(number, number));

export const isChartsLineResult = objectOf({
  daily_line_stats: objectOf({
    sent_count_by_hour: isStat,
    open_count_by_hour: isStat,
    tracked_click_count_by_hour: isStat,
  }),
});
